import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Faq() {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true }) as {
    q: string;
    a: string;
  }[];

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Seo title={t("faq.metaTitle")} description={t("faq.metaDesc")} path="/faq" />
      <Header />
      <main id="main" tabIndex={-1} className="flex-1 outline-none">
        <section className="w-full px-6 pt-16 pb-12 md:pt-24 md:pb-16">
          <div className="max-w-[1400px] mx-auto">
            <div className="flex items-center gap-4 ed-eyebrow text-muted-foreground animate-fade-in">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-brand ed-blink" />
              {t("faq.eyebrow")}
            </div>

            <h1 className="ed-display mt-8 max-w-[16ch] animate-fade-in">
              {t("faq.title")}<span className="text-brand">.</span>
            </h1>

            <p className="ed-serif mt-8 text-2xl md:text-3xl max-w-2xl text-foreground/85 animate-fade-in-delay-1">
              {t("faq.sub")}
            </p>
          </div>
        </section>

        <div className="ed-rule max-w-[1400px] mx-auto" />

        <section className="w-full px-6 py-12 md:py-20">
          <ol className="max-w-[1100px] mx-auto">
            {items.map((item, i) => (
              <li
                key={item.q}
                className="grid gap-4 md:grid-cols-[auto_1fr] md:gap-12 py-10 border-b border-border"
              >
                <span className="ed-serif text-3xl md:text-4xl text-muted-foreground">
                  0{i + 1}
                </span>
                <div>
                  <h2 className="ed-headline">{item.q}</h2>
                  <p className="mt-4 text-lg text-muted-foreground leading-relaxed max-w-2xl">
                    {item.a}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </section>
      </main>
      <Footer />
    </div>
  );
}
